// utils
import { v4 as uuid } from 'uuid'
// types
import { FieldSource, FieldType } from 'types/graphql'

export const DATA_SOURCE_OPTIONS = [
  { label: 'Plans', value: FieldSource.Plans },
  { label: 'Plan Types', value: FieldSource.PlanTypes },
  { label: 'Actions', value: FieldSource.Actions },
  { label: 'Objectives', value: FieldSource.Objectives },
  { label: 'Indicators', value: FieldSource.Kpis },
  { label: 'People', value: FieldSource.Users },
  { label: 'Positions', value: FieldSource.Positions },
  { label: 'Locations', value: FieldSource.Locations },
  {
    label: 'Business Activities',
    value: FieldSource.BusinessActivities
  },
  {
    label: 'Business Processes',
    value: FieldSource.BusinessProcesses
  },
  {
    label: 'Business Units',
    value: FieldSource.BusinessUnits
  }
]

// as const — see the matching comment on FORM_SELECT_SECURITY_VALUES
// (constants/security.ts) for why this matters.
export const FORMAT_VALUES = {
  CURRENCY: 'CURRENCY',
  NUMBER: 'NUMBER'
} as const

export const DATE_FORMAT_VALUES = {
  TIME: 'TIME',
  DATE: 'DATE',
  DATE_TIME: 'DATE_TIME'
} as const

export const FORMAT_OPTIONS = [
  { label: 'Currency', value: FORMAT_VALUES.CURRENCY },
  { label: 'Number', value: FORMAT_VALUES.NUMBER }
]

export const DATE_FORMAT_OPTIONS = [
  { label: 'Time', value: DATE_FORMAT_VALUES.TIME },
  { label: 'Date', value: DATE_FORMAT_VALUES.DATE },
  { label: 'Date & Time', value: DATE_FORMAT_VALUES.DATE_TIME }
]

export const OBJECT_ENTITY_NAMES = {
  PLAN: 'Plan',
  OBJECTIVE: 'Objective',
  ACTION: 'Action',
  KPI: 'Indicator',
  RESOURCE: 'Resource',
  GROUP: 'Group',
  REVIEW: 'Review'
}

export const PROPERTIES_LISTS = {
  COMMON: 'COMMON',
  GLOBAL: 'GLOBAL',
  PLAN_TYPE: 'PLAN_TYPE'
}

export const COMMON_FIELDS = [
  { active: true, id: uuid(), label: 'Switch', fieldType: FieldType.Switch },
  { active: true, id: uuid(), label: 'Date & Time', fieldType: FieldType.Date },
  { active: true, id: uuid(), label: 'Picklist', fieldType: FieldType.PickList },
  { active: true, id: uuid(), label: 'Text', fieldType: FieldType.Text },
  { active: true, id: uuid(), label: 'Number', fieldType: FieldType.Number },
  { active: true, id: uuid(), label: 'Lookup', fieldType: FieldType.Lookup },
  { active: true, id: uuid(), label: 'Tag List', fieldType: FieldType.Tag },
  { active: true, id: uuid(), label: 'Document & Link', fieldType: FieldType.DocumentOrLink }
]

export const RISK_TEMPLATE_FIELDS = [
  { active: true, id: uuid(), label: 'Section', fieldType: FieldType.Section },
  ...COMMON_FIELDS,
  { active: true, id: uuid(), label: 'Address', fieldType: FieldType.Address },
  { active: true, id: uuid(), label: 'Table', fieldType: FieldType.Table },
  { active: true, id: uuid(), label: 'Risk Matrix', fieldType: FieldType.RiskMatrix },
  { active: true, id: uuid(), label: 'Label', fieldType: FieldType.Label },
  { active: true, id: uuid(), label: 'Another Form', fieldType: FieldType.Form },
  { active: true, id: uuid(), label: 'Linked Form', fieldType: FieldType.LinkedForm },
  { active: true, id: uuid(), label: 'Record Links', fieldType: FieldType.RecordLinks },
  { active: true, id: uuid(), label: 'Parent Fields', fieldType: FieldType.ParentRelatedForms },
  { active: true, id: uuid(), label: 'Injury Master Links', fieldType: FieldType.InjuryMasterLinks },
  { active: true, id: uuid(), label: 'Injury Master Parent Links', fieldType: FieldType.InjuryMasterParentLinks }
]

// Field types that never carry their own value (containers/layout or link-only fields) — excluded from
// value pickers, mandatory settings, column/property sources, etc.
export const NO_VALUE_FIELD_TYPES = [
  FieldType.Table,
  FieldType.Label,
  FieldType.Section,
  FieldType.InjuryMasterLinks,
  FieldType.InjuryMasterParentLinks,
  FieldType.RecordLinks,
  FieldType.ParentRelatedForms
]
